export default "__VITE_ASSET__C3b4s5TY__"